import { all } from 'redux-saga/effects';
import { availableLanguagesSaga } from './availableLanguages/slice/saga';
import { salesOrganizationSaga } from './salesOrganisation/slice/saga';
import { shoppingCartSaga } from './shoppingCart/slice/saga';
import { userSaga } from './user/slice/saga';
import { itemsSaga } from './items/slice/saga';
import { singleItemSaga } from './singleItem/slice/saga';
import { attributesSaga } from './attributes/slice/saga';
import { addToCartSaga } from './addToCart/slice/saga';
import { gasketsSaga } from './gaskets/slice/saga';
import { changeLanguageSaga } from './erpSystem/slice/saga';
import { shapeValidationSaga } from './shapeValidation/slice/saga';

// [IMPORT NEW Sagas ABOVE] < Needed for generating containers seamlessly
export default function* rootSaga() {
  yield all([
    availableLanguagesSaga(),
    salesOrganizationSaga(),
    shoppingCartSaga(),
    userSaga(),
    attributesSaga(),
    itemsSaga(),
    singleItemSaga(),
    changeLanguageSaga(),
    shapeValidationSaga(),
    addToCartSaga(),
    gasketsSaga(),

    // [INVOKE NEW Saga Above] < Needed for generating containers seamlessly
  ]);
}
